import(/* webpackMode: "eager", webpackExports: ["ClaimableRewardsTab"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/claim/rewards/_common/ui/claimable-rewards-tab.tsx");
